module.exports = __webpack_public_path__ + "img/t2-24.c6ea44a1.svg";